import bemCssModules from 'bem-css-modules';
import type { CSSProperties, VFC } from 'react';

import QuestionItemModuleCss from './QuestionItem.module.css';
import type { Question } from '~/models/supportCenter';

const block = bemCssModules(QuestionItemModuleCss);

interface QuestionItemProps {
  questionItem: Question;
  truncate?: number;
}

const clearTagFromString = (inputString: string) => inputString.replace(/<\/?[^>]+(>|$)/g, '');

export const QuestionItem: VFC<QuestionItemProps> = ({ questionItem, truncate }) => (
  <a
    className={block()}
    href={questionItem.AnswerUrl}
  >
    <h3
      className={block('title', { truncate: Boolean(truncate) })}
      style={{ '--truncate-lines': truncate } as CSSProperties}
    >
      {clearTagFromString(questionItem.Question)}
    </h3>
    <span className={`${block('icon')} icon v-icon-arrow-right-thin`} />
  </a>
);
